import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";

// OBTENER TODAS LAS CATEGORIAS
export const obtenerSubCategorias = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/SubCategorias`, "GET");
  return respuesta;
};

// OBTENER TODAS LAS CATEGORIAS ACTIVAS
export const obtenerSubCategoriasAct = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/SubCategorias/SubCategoriasAct`, "GET");
  return respuesta;
};

// MODIFICAR CATEGORIA
export const modificarSubCategoria = async (data) => {
  const respuesta = await PrivateInterceptor(`Base/Global/SubCategorias/add`,"POST",data);
  return respuesta;
};

// AGREGAR CATEGORIA
export const addSubCategoria = async (data) => {
  const respuesta = await PrivateInterceptor(`Base/Global/SubCategorias/add`,"POST",data);
  return respuesta;
};

export const getSubCategoriasConCategorias = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/SubCategorias/getSubCategoriasConCategorias`, "GET");
  return respuesta;
};
